import { writeToCache } from "@/utils/cache";

export function setLocale(state, payload) {
  state.locale = payload;
  writeToCache("locale", payload);
}
